function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import { useRef } from 'react';
import classnames from 'classnames/bind';
import { MenuItem } from "../MenuItem/MenuItem";
import { Popup } from "../../Popup/Popup/Popup";
import styles from "./Menu.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var Menu = function Menu(_ref) {
  var _ref$compactSize = _ref.compactSize,
    compactSize = _ref$compactSize === void 0 ? false : _ref$compactSize,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? '' : _ref$style,
    _ref$menuItems = _ref.menuItems,
    menuItems = _ref$menuItems === void 0 ? [] : _ref$menuItems,
    _ref$styleText = _ref.styleText,
    styleText = _ref$styleText === void 0 ? '' : _ref$styleText,
    _ref$styleSubItem = _ref.styleSubItem,
    styleSubItem = _ref$styleSubItem === void 0 ? '' : _ref$styleSubItem;
  var popupComponents = useRef([]);
  var togglePopup = function togglePopup(index) {
    var currentPopups = popupComponents.current;
    if (currentPopups) {
      currentPopups[index].togglePopup();
    }
  };
  var renderSecondaryMenuItems = function renderSecondaryMenuItems(items, styleSubItem) {
    return items === null || items === void 0 ? void 0 : items.map(function (subMenuItem, i) {
      return /*#__PURE__*/_jsx(MenuItem, {
        styleText: styleSubItem,
        menuItem: subMenuItem
      }, i);
    });
  };
  return /*#__PURE__*/_jsx("ul", {
    className: classnames(styles.list, style),
    "data-e2e-name": "navigation_menu",
    children: menuItems === null || menuItems === void 0 ? void 0 : menuItems.map(function (menuItem, index) {
      var menuItemChildren = null;
      var hasDropdown = menuItem.subMenu && menuItem.subMenu.length > 0 && menuItem.url.length === 0;
      if (hasDropdown) {
        menuItemChildren = renderSecondaryMenuItems(menuItem.subMenu, styleSubItem);
      }
      var props = {
        compactSize: compactSize,
        icon: menuItem.icon,
        subMenu: menuItem.subMenu,
        menuItem: menuItem,
        key: index,
        styleText: styleText
      };
      return /*#__PURE__*/_jsx("li", {
        className: styles.listItem,
        children: hasDropdown ? /*#__PURE__*/_jsx(Popup, {
          ref: function ref(popupComponent) {
            var currentPopups = popupComponents.current;
            if (popupComponent) {
              currentPopups[index] = popupComponent;
            }
          },
          handle: /*#__PURE__*/_jsx(MenuItem, _objectSpread({
            "aria-haspopup": true,
            onClick: function onClick() {
              return togglePopup(index);
            }
          }, props)),
          config: {
            position: 'bottom',
            offset: -10,
            hideClose: true
          },
          popupClass: styles.popup,
          contentClass: styles.popupContent,
          children: menuItemChildren
        }) : /*#__PURE__*/_jsx(_Fragment, {
          children: /*#__PURE__*/_jsx(MenuItem, _objectSpread({}, props))
        })
      }, index);
    })
  });
};